import React, {useState} from 'react';
import {PDFPreview} from '../../../FilePreview';
import {InteractionsMenuItem,} from '../../InteractionsMenuItems';
import AbstractModalView from '../../../AbstractModalView';
import AnimatedUploadingFilePopUp from '../../../AnimatedUploadingFilePopUp';
import styles from './styles.module.scss';

const DocumentPreview = ({
                           fileName,
                           fileID,
                           content,
                           shumaId,
                           editPDFPages,
                           getFileList,
                           updateFile,
                         }) => {
  const [loading, setLoading] = useState(false);

  const handleOpen = openModal => async () => {
    if (!Boolean(content)) {
      setLoading(true);
      await updateFile();
    }
    openModal();
    setLoading(false);
  };

  const mapPages = () => {
    /* Direct reading of the DOM tree is used to avoid re-rendering
       the PDF document after toggling a checkbox */
    let result = [];
    const checkboxes = document.getElementsByName('pdf-page-checkbox');
    checkboxes.forEach(checkbox => {
      if (checkbox.checked) {
        result = [...result, checkbox.getAttribute('data-page-number')];
      }
    });

    return result;
  };

  const handleConfirm = closeModal => () => {
    editPDFPages({
      shumaId,
      fileID,
      pages: mapPages(),
    })
      .then(() => getFileList({shumaId}))
      .then(() => updateFile())
      .then(() => closeModal())
  };

  return (
    <>
      <AnimatedUploadingFilePopUp show={loading}/>
      <AbstractModalView
        subPath={`edit-pdf-${fileID}`}
        triggerContent={({openModal}) => (
          <InteractionsMenuItem
            label={fileName}
            icon={null}
            onClick={handleOpen(openModal)}
            customClassnames={styles.editMetaDataButton}
          />
        )}
        modalContent={({closeModal}) => (
          <div className={styles.editPDFcontainer}>
            <PDFPreview
              url={content}
              editMode={true}
            />
            <div className={styles.modalButtons}>
              <button
                type="button"
                className={styles.buttonCancel}
                onClick={closeModal}
              >
                <span>ביטול</span>
              </button>
              <button
                type="button"
                className={styles.buttonSubmit}
                onClick={handleConfirm(closeModal)}
              >
                <span>עריכה</span>
              </button>
            </div>
          </div>
        )}
        modalContainerClassName={styles.modal}
      />
    </>
  );
};

export default DocumentPreview;